function configs(chart) {
  const backgroundColors = [
     "#f44335",
     "#344767",
     "#4CAF50",
     "#fb8c00",
     "#e91e63",
     "#1A73E8"
  ];

  return {
    data: {
      labels: chart?.labels,
      datasets: [
        {
          label: chart?.datasets?.labels,
          weight: 9,
          cutout: 0,
          tension: 0.9,
          pointRadius: 2,
          borderWidth: 2,
          backgroundColor: backgroundColors,
          fill: false,
          data: chart?.datasets,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          maxWidth: 200,
          position: chart.rtl? 'right' : 'left',
          rtl : chart.rtl,
          labels: {
            filter: chart.legendFilter ? chart.legendFilter : undefined,
            usePointStyle: true,
            pointStyle: 'circle',
            padding: 20,
            font: {
              family: "IRANSans"
            }
          }
        },
        tooltip: {
          callbacks: chart.tooltipCallback ? chart.tooltipCallback : undefined,
          font: {
            family: "IRANSans"
          }
        },
      },
      interaction: {
        intersect: false,
        mode: "nearest"
      },
      scales: {
        y: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
        x: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
      },
      animation: {
        duration: 0
      }
    },
  };
}

export default configs;
